<template>
    <div v-if="can('settings.booking-list')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/administration" tag="li" class="breadcrumb-item"><a href="">{{i18n("Administration")}}</a></router-link>
                <li class="breadcrumb-item active" aria-current="page"> {{i18n("Booking List")}}</li>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n("Booking List")}}</h1>
            </div>
            <div class="base_box_cnt">
                <div class="row">
                    <div class="offset-md-8 col-md-4 col-12">
                        <form action="" class="search" v-on:submit.prevent>
                            <div class="base_input_bx">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Filter')" v-model="search" @keyup="filterBookings">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <div class="cloading" v-show="isLoading"></div>
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">
                                    <button class="w-100 text-left" type="button">
                                        {{i18n("Title")}}
                                        <span class="float-right"><i class="mdi mdi-arrow-up"></i></span>
                                    </button>
                                </th>
                                <th scope="col">{{i18n('Status')}}</th>
                                <th scope="col">{{i18n("Action")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="booking in filteredBookings">
                                <td>{{booking.name}}</td>
                                <td class="text-center" v-if="can('locations.edit')">
                                    <span class="badge badge-success cur-p" v-if="booking.status === 10" @click="lockOrUnlock(booking, false)">Актив</span>
                                    <span class="badge badge-danger cur-p" v-else @click="lockOrUnlock(booking, true)">{{i18n("Turned off")}}</span>
                                </td><td v-else></td>
                                <td class="text-center">
                                    <button v-if="can('bookings.update')" type="button" class="btn-icon" @click="deleteItem(booking)">
                                        <i class="mdi mdi-minus-circle text-danger"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <pagination :links="links" :url="'locations'"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../../components/Pagination";
    export default {
        name: "BookingList",
        components: {Pagination},
        data() {
            return {
                isLoading: false,
                bookings: [],
                filteredBookings: [],
                search: '',
                links: {},
                page: 1
            }
        },
        methods: {
            filterBookings(){

            }
        },
        computed: {
            filteredBookings(){
                return [];
            }
        }
    }
</script>

<style scoped>

</style>